import { defineStore } from "pinia";

/**
 * Состояние приложения как установленного (CAB-489).
 *
 * Стор, а не локальные ref'ы: о готовом обновлении и о возможности установки
 * узнаёт слой регистрации воркера, а показывают их разные места кабинета —
 * уведомление в углу и пункт в настройках.
 */
export const usePwaStore = defineStore("pwa", {
  state: () => ({
    /** Новая версия скачана и ждёт перезапуска. */
    isUpdateReady: false,
    /** Браузер разрешил предложить установку (Android/desktop Chrome). */
    canInstall: false,
    /** Кабинет открыт как установленное приложение, а не вкладкой браузера. */
    isInstalled: false,
  }),
});
